<template>
  <section class="relative py-28 bg-surface-brand-low">
    <div class="relative mx-auto max-w-full px-24 md:max-w-[900px] md:px-32">
      <SeoBlock />
    </div>
  </section>
</template>

<script setup lang="ts">
import { useHead } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'

import translations from './HelpCenterHome.translations'
import SeoBlock from './components/SeoBlock/SeoBlock.vue'

const i18n = useI18n()

useHead({
  title: i18n(translations.helpCenterPageTitle),
  htmlAttrs: { lang: useI18nLocale() },
})
</script>
